import { TrackerPosition } from "@/interfaces";
import { format } from "date-fns";
import L from "leaflet";
import { Power } from "lucide-react";
import React from "react";
import { Marker, Popup } from "react-leaflet";
import { DefaultIcon, StartFinishLabelIcon } from "../Icons";

L.Marker.prototype.options.icon = DefaultIcon();

interface StartFinishMarkerProps {
  positionData: TrackerPosition;
  isStart: boolean;
}

const StartFinishMarker = ({
  positionData,
  isStart,
}: StartFinishMarkerProps) => {
  const label = isStart ? "Início" : "Fim";
  const driverName = positionData.driver?.name || "";
  return (
    <React.Fragment>
      <Marker position={[positionData.latitude, positionData.longitude]}>
        <Popup>
          <div className="text-sm p-4 w-64">
            <div className="mb-1 text-black">
              Data: {format(new Date(positionData.date), "dd/MM/yyyy HH:mm:ss")}
            </div>
            <div className="mb-1 text-black flex items-center">
              Ignição: {positionData.ignition ? "Ligada" : "Desligada"}
              <Power
                className={`ml-1 ${positionData.ignition ? "text-green-500" : "text-red-500"}`}
              />
            </div>
            <div className="mb-1 text-black">
              Velocidade: {positionData.speed}km/h
            </div>
            {driverName && (
              <div className="mb-1 text-black">Condutor: {driverName}</div>
            )}
          </div>
        </Popup>
      </Marker>

      <Marker
        position={[positionData.latitude, positionData.longitude]}
        icon={StartFinishLabelIcon(label)}
      />
    </React.Fragment>
  );
};

export default StartFinishMarker;
